var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.668 10.4583C17.5013 10 17.3346 9.54167 17.3346 9.08333C17.3346 8.625 17.668 8.16667 18.0846 7.83333C18.793 7.25 19.168 6.375 19.168 5.41667C19.168 3.58333 17.9596 2 15.8346 2C13.8763 2 12.7096 3.33333 12.543 4.95833C12.543 5.125 12.6263 5.25 12.7513 5.33333C14.3346 6.33333 15.293 8.08333 15.293 10.2083C15.293 11.7917 14.668 13.2083 13.543 14.2083C13.4596 14.2917 13.4596 14.4583 13.543 14.5417C13.8346 14.75 14.5013 15.0417 14.918 15.25C15.043 15.2917 15.1263 15.3333 15.2513 15.3333H20.293C21.2513 15.3333 22.0013 14.5417 22.0013 13.6667V13.4167C22.0013 11.9583 20.418 11.1667 18.668 10.4583Z",
    fill: "#8494AE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0833 16.2487C11.6667 15.6654 11.4583 15.1654 11.4583 14.6237C11.4583 14.082 11.875 13.5404 12.3333 13.1237C13.1667 12.4154 13.625 11.4154 13.625 10.2487C13.625 8.08203 12.2083 6.20703 9.625 6.20703C7.08333 6.20703 5.625 8.08203 5.625 10.2487C5.625 11.4154 6.08333 12.4154 6.91667 13.1237C7.375 13.5404 7.79167 14.082 7.79167 14.6237C7.79167 15.1654 7.58333 15.707 6.125 16.2487C4.04167 17.082 2 18.0404 2 19.7904V19.9154V20.332C2 21.2487 2.75 21.9987 3.70833 21.9987H15.25C16.2083 21.9987 17 21.2487 17 20.332V19.9154V19.7487C17 18.0404 15.1667 17.082 13.0833 16.2487Z",
    fill: "#8494AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.c3193b681c741d690c8a8b78c5ebba0f.svg";
export { ForwardRef as ReactComponent };